import React from 'react';
export const Testimonials = () => {
  const testimonials = [{
    content: "I couldn't explain my welding services in a way that got me jobs. Mayhave Copy wrote scripts that actually connect with customers, and now I'm booked solid with mobile welding gigs.",
    author: 'Christian Garza',
    role: 'Owner, The Wizard Mobile Welding Channel',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nwURiek9o9YRNbApa3H73A/IMG_1557.jpg'
  }, {
    content: "Mayhave Copy helped us with email engagement, and now we're finally connecting with our audience!",
    author: 'Diluvina Walker',
    role: 'Owner, Starlight Pixel',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fgN1Ry6oRDmtXKnDyFNp6e/IMG_1555.jpg'
  }, {
    content: 'After Mayhave Copy wrote our Facebook ads, we started getting a steady stream of clients every month.',
    author: 'Juvenal Patino',
    role: 'Owner, Patino Landscaping',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pREqA5BowdJdovwrNqYUJF/IMG_3570.jpg'
  }];
  return <section id="testimonials" className="py-12 bg-[#f9fafb]" data-id="element-610">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-611">
        <div className="lg:text-center" data-id="element-612">
          <h2 className="text-base text-green-600 font-semibold tracking-wide uppercase" data-id="element-613">
            TESTIMONIALS
          </h2>
          <p className="mt-2 text-4xl font-bold mb-4 text-[#2c3e50]" data-id="element-614">
            Results That Speak For Themselves
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-600 lg:mx-auto" data-id="element-615">
            Don't just take our word for it. Here's what our clients have to
            say.
          </p>
        </div>
        <div className="mt-10" data-id="element-616">
          <div className="space-y-8 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8" data-id="element-617">
            {testimonials.map(testimonial => <div key={testimonial.author} className="bg-white p-6 rounded-lg shadow-md transition-transform duration-300 hover:-translate-y-2" data-id="element-618">
                <p className="text-gray-600 italic mb-4" data-id="element-619">
                  "{testimonial.content}"
                </p>
                <div className="flex items-center" data-id="element-620">
                  <img className="h-10 w-8 rounded-full mr-3" src={testimonial.image} alt={testimonial.author} data-id="element-621" />
                  <div data-id="element-622">
                    <p className="text-sm font-medium text-gray-900" data-id="element-623">
                      {testimonial.author}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-624">{testimonial.role}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};